export const REGISTRADO = 1;
export const IMPORTADO = 2;
export const ANULADO = 3;
